import yandexDirectLogo from "@/shared/assets/yandex-direct.svg";
import { Button, CardDescription, CardHeader, CardTitle } from "@heroui/react";
import { AlertTriangle, ArrowRight, ChevronRight } from "lucide-react";
import { Link } from "react-router-dom";
import {
  formatCampaignType,
  formatPlacementTypes,
} from "../lib/formatters";
import type { Campaign } from "../model/types";

export interface CampaignCardHeaderProps {
  campaign: Campaign;
  hasProblems?: boolean;
}

export const CampaignCardHeader = ({
  campaign,
  hasProblems,
}: CampaignCardHeaderProps) => {
  const campaignId = campaign.campaign_id || campaign.id;
  const typeLabel = formatCampaignType(campaign.type);
  const placementLabel = formatPlacementTypes(
    campaign.placement_types,
    campaign.placement,
  );

  return (
    <CardHeader className="flex flex-row items-center justify-between gap-4">
      {/* Логотип Яндекс Директа + Название и статус */}
      <div className="flex items-center gap-3 min-w-0">
        <img
          src={yandexDirectLogo}
          alt="Яндекс Директ"
          className="w-9 h-9 object-contain shrink-0"
        />
        <div className="min-w-0">
          <div className="flex items-center gap-2">
            <CardTitle className="truncate">{campaign.name}</CardTitle>
            {hasProblems && (
              <AlertTriangle className="w-4 h-4 text-rose-500 shrink-0" />
            )}
          </div>
          <CardDescription>
            {typeLabel} • {placementLabel}
          </CardDescription>
        </div>
      </div>

      <ChevronRight className="w-4 h-4 mr-2" />
    </CardHeader>
  );
};
